<template>
  <div class="actions">
    <Button
      v-b-popover.hover.blur.top="'Редактировать'"
      class="edit"
      icon="edit"
      size="iconic"
      @click="$emit('edit', entry)"
    />
    <Button
      v-if="canEdit"
      v-b-popover.hover.blur.top="'Удалить'"
      class="remove"
      :icon="{ icon: 'trash', color: 'secondary' }"
      size="iconic"
      @click="$emit('remove', entry)"
    />
  </div>
</template>

<script>
import Button from "@/components/controls2/Button.vue";

export default {
  components: {
    Button,
  },
  props: {
    entry: {
      type: Object,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.actions {
    display: flex;
}

.edit {
    margin-left: 1px;
}

.remove {
    margin-top: -2px;
    margin-left: 12px;
}
</style>
